import { Button, Menu, MenuItem } from '@mui/material';
import { ArrowDropDownIcon } from '@mui/x-date-pickers';
import { useIsMobile } from '@side/pantry';
import Link from 'next/link';
import { useState } from 'react';
import {
  TrackReferralsEvent,
  useTrackReferralsAnalytics,
} from '$analytics/useTrackAnalytics/domains/referrals';

interface Props {
  menuOptions: {
    href?: string;
    onClick?: () => Promise<void>;
    disabled?: boolean;
    buttonText: string;
  }[];
}

export const CreateInteractionButtonDropdown = ({ menuOptions }: Props) => {
  const isMobile = useIsMobile();
  const trackEvent = useTrackReferralsAnalytics();

  const [buttonAnchor, setButtonAnchor] = useState<null | HTMLButtonElement>(
    null,
  );
  const isMenuOpen = Boolean(buttonAnchor);
  function openMenu(event: React.MouseEvent<HTMLButtonElement>) {
    setButtonAnchor(event.currentTarget);
  }

  return (
    <>
      <Button
        onClick={(event) => {
          event.preventDefault();
          openMenu(event);

          trackEvent(TrackReferralsEvent.ClickCreateTransactionButton, {
            eventContainer: 'referral_list_view',
          });
        }}
        size={isMobile ? 'small' : 'medium'}
        sx={(theme) => ({
          height: {
            xs: 20,
            md: '100%',
          },
          padding: 0,
          '&:active,&:hover': {
            backgroundColor: 'transparent',
            color: 'primary.dark',
          },
          fontSize: theme.typography.body2.fontSize,
          lineHeight: theme.typography.body2.lineHeight,
        })}
        disableRipple
      >
        Create
        <ArrowDropDownIcon sx={{ height: 18, marginLeft: 1, width: 18 }} />
      </Button>
      <Menu
        anchorEl={buttonAnchor}
        anchorOrigin={{
          horizontal: 'left',
          vertical: 'bottom',
        }}
        onClose={() => setButtonAnchor(null)}
        open={isMenuOpen}
        transformOrigin={{
          horizontal: 'left',
          vertical: 'top',
        }}
      >
        {menuOptions
          .sort((a, b) => (a.buttonText <= b.buttonText ? -1 : 1))
          .map(({ href, buttonText, onClick, disabled }) => {
            return (
              <MenuItem key={href} disabled={disabled}>
                <Button
                  href={href}
                  LinkComponent={Link}
                  onClick={() => void onClick?.()}
                  disabled={disabled}
                  sx={{
                    height: '100%',
                    justifyContent: 'flex-start',
                  }}
                  variant="link"
                >
                  {buttonText}
                </Button>
              </MenuItem>
            );
          })}
      </Menu>
    </>
  );
};
